// ============================================================================
// Registro de idiomas (oct-2026).
//
// Agregar un idioma:
//   1. diccionarios/<codigo>.ts tipado como `Diccionario` (el typecheck exige
//      todas las claves de es.ts).
//   2. una entrada en IDIOMAS (abajo).
//   3. su código en IDIOMAS_SOPORTADOS del backend (apps/api/src/regional/monedas.js).
//   4. habilitarlo en Features.
// El nombre va en su propio idioma ("English", no "Inglés"): así lo reconoce
// quien lo necesita.
// ============================================================================
import { es, type Clave, type Diccionario } from './diccionarios/es.ts';
import { en } from './diccionarios/en.ts';

export type CodigoIdioma = 'es' | 'en';

export interface Idioma {
  codigo: CodigoIdioma;
  nombre: string;
  diccionario: Diccionario;
}

export const IDIOMA_DEFECTO: CodigoIdioma = 'es';

export const IDIOMAS: readonly Idioma[] = [
  { codigo: 'es', nombre: 'Español', diccionario: es },
  { codigo: 'en', nombre: 'English', diccionario: en },
];

export function esCodigoIdioma(v: unknown): v is CodigoIdioma {
  return IDIOMAS.some(i => i.codigo === v);
}

export function getIdioma(codigo: string | null | undefined): Idioma {
  return IDIOMAS.find(i => i.codigo === codigo) || IDIOMAS[0];
}

export type { Clave, Diccionario };
